import i18n from "@/assets/lang/index.js";
const monthsList = [
  [
    {
      value: "1",
      text: "JanuaryNum",
      selected: false,
      isCurrent: false
    },
    {
      value: "2",
      text: "FebruaryNum",
      selected: false,
      isCurrent: false
    },
    {
      value: "3",
      text: "MarchNum",
      selected: false,
      isCurrent: false
    },
    {
      value: "4",
      text: "AprilNum",
      selected: false,
      isCurrent: false
    }
  ],
  [
    {
      value: "5",
      text: "MayNum",
      selected: false,
      isCurrent: false
    },
    {
      value: "6",
      text: "JuneNum",
      selected: false,
      isCurrent: false
    },
    {
      value: "7",
      text: "JulyNum",
      selected: false,
      isCurrent: false
    },
    {
      value: "8",
      text: "AugustNum",
      selected: false,
      isCurrent: false
    }
  ],
  [
    {
      value: "9",
      text: "SeptemberNum",
      selected: false,
      isCurrent: false
    },
    {
      value: "10",
      text: "OctoberNum",
      selected: false,
      isCurrent: false
    },
    {
      value: "11",
      text: "NovemberNum",
      selected: false,
      isCurrent: false
    },
    {
      value: "12",
      text: "DecemberNum",
      selected: false,
      isCurrent: false
    }
  ]
];
const checkTimeDaysList = [
  [
    {
      value: "1",
      text: "1",
      selected: false,
      isCurrent: false
    },
    {
      value: "2",
      text: "2",
      selected: false,
      isCurrent: false
    },
    {
      value: "3",
      text: "3",
      selected: false,
      isCurrent: false
    },
    {
      value: "4",
      text: "4",
      selected: false,
      isCurrent: false
    },
    {
      value: "5",
      text: "5",
      selected: false,
      isCurrent: false
    },
    {
      value: "6",
      text: "6",
      selected: false,
      isCurrent: false
    },
    {
      value: "7",
      text: "7",
      selected: false,
      isCurrent: false
    }
  ],
  [
    {
      value: "8",
      text: "8",
      selected: false,
      isCurrent: false
    },
    {
      value: "9",
      text: "9",
      selected: false,
      isCurrent: false
    },
    {
      value: "10",
      text: "10",
      selected: false,
      isCurrent: false
    },
    {
      value: "11",
      text: "11",
      selected: false,
      isCurrent: false
    },
    {
      value: "12",
      text: "12",
      selected: false,
      isCurrent: false
    },
    {
      value: "13",
      text: "13",
      selected: false,
      isCurrent: false
    },
    {
      value: "14",
      text: "14",
      selected: false,
      isCurrent: false
    }
  ],
  [
    {
      value: "15",
      text: "15",
      selected: false,
      isCurrent: false
    },
    {
      value: "16",
      text: "16",
      selected: false,
      isCurrent: false
    },
    {
      value: "17",
      text: "17",
      selected: false,
      isCurrent: false
    },
    {
      value: "18",
      text: "18",
      selected: false,
      isCurrent: false
    },
    {
      value: "19",
      text: "19",
      selected: false,
      isCurrent: false
    },
    {
      value: "20",
      text: "20",
      selected: false,
      isCurrent: false
    },
    {
      value: "21",
      text: "21",
      selected: false,
      isCurrent: false
    }
  ],
  [
    {
      value: "22",
      text: "22",
      selected: false,
      isCurrent: false
    },
    {
      value: "23",
      text: "23",
      selected: false,
      isCurrent: false
    },
    {
      value: "24",
      text: "24",
      selected: false,
      isCurrent: false
    },
    {
      value: "25",
      text: "25",
      selected: false,
      isCurrent: false
    }
  ]
];
// value加上0是为了匹配上接口返回的数据
const hourNumList = [
  {
    text: "00",
    value: "00",
    selected: false
  },
  {
    text: "01",
    value: "01",
    selected: false
  },
  {
    text: "02",
    value: "02",
    selected: false
  },
  {
    text: "03",
    value: "03",
    selected: false
  },
  {
    text: "04",
    value: "04",
    selected: false
  },
  {
    text: "05",
    value: "05",
    selected: false
  },
  {
    text: "06",
    value: "06",
    selected: false
  },
  {
    text: "07",
    value: "07",
    selected: false
  },
  {
    text: "08",
    value: "08",
    selected: false
  },
  {
    text: "09",
    value: "09",
    selected: false
  },
  {
    text: "10",
    value: "10",
    selected: false
  },
  {
    text: "11",
    value: "11",
    selected: false
  },
  {
    text: "12",
    value: "12",
    selected: false
  },
  {
    text: "13",
    value: 13,
    selected: false
  },
  {
    text: "14",
    value: "14",
    selected: false
  },
  {
    text: "15",
    value: "15",
    selected: false
  },
  {
    text: "16",
    value: "16",
    selected: false
  },
  {
    text: "17",
    value: 17,
    selected: false
  },
  {
    text: "18",
    value: "18",
    selected: false
  },
  {
    text: "19",
    value: "19",
    selected: false
  },
  {
    text: "20",
    value: 20,
    selected: false
  },
  {
    text: "21",
    value: "21",
    selected: false
  },
  {
    text: "22",
    value: "22",
    selected: false
  },
  {
    text: "23",
    value: "23",
    selected: false
  }
];
const minNumList = [
  {
    text: "00",
    value: "00",
    selected: false
  },
  {
    text: "01",
    value: "01",
    selected: false
  },
  {
    text: "02",
    value: "02",
    selected: false
  },
  {
    text: "03",
    value: "03",
    selected: false
  },
  {
    text: "04",
    value: "04",
    selected: false
  },
  {
    text: "05",
    value: "05",
    selected: false
  },
  {
    text: "06",
    value: "06",
    selected: false
  },
  {
    text: "07",
    value: "07",
    selected: false
  },
  {
    text: "08",
    value: "08",
    selected: false
  },
  {
    text: "09",
    value: "09",
    selected: false
  },
  {
    text: "10",
    value: "10",
    selected: false
  },
  {
    text: "11",
    value: "11",
    selected: false
  },
  {
    text: "12",
    value: "12",
    selected: false
  },
  {
    text: "13",
    value: "13",
    selected: false
  },
  {
    text: "14",
    value: "14",
    selected: false
  },
  {
    text: "15",
    value: "15",
    selected: false
  },
  {
    text: "16",
    value: "16",
    selected: false
  },
  {
    text: "17",
    value: "17",
    selected: false
  },
  {
    text: "18",
    value: "18",
    selected: false
  },
  {
    text: "19",
    value: "19",
    selected: false
  },
  {
    text: "20",
    value: "20",
    selected: false
  },
  {
    text: "21",
    value: "21",
    selected: false
  },
  {
    text: "22",
    value: "22",
    selected: false
  },
  {
    text: "23",
    value: "23",
    selected: false
  },
  {
    text: "24",
    value: "24",
    selected: false
  },
  {
    text: "25",
    value: "25",
    selected: false
  },
  {
    text: "26",
    value: "26",
    selected: false
  },
  {
    text: "27",
    value: "27",
    selected: false
  },
  {
    text: "28",
    value: "28",
    selected: false
  },
  {
    text: "29",
    value: "29",
    selected: false
  },
  {
    text: "30",
    value: "30",
    selected: false
  },
  {
    text: "31",
    value: "31",
    selected: false
  },
  {
    text: "32",
    value: "32",
    selected: false
  },
  {
    text: "33",
    value: "33",
    selected: false
  },
  {
    text: "34",
    value: "34",
    selected: false
  },
  {
    text: "35",
    value: "35",
    selected: false
  },
  {
    text: "36",
    value: "36",
    selected: false
  },
  {
    text: "37",
    value: "37",
    selected: false
  },
  {
    text: "38",
    value: "38",
    selected: false
  },
  {
    text: "39",
    value: "39",
    selected: false
  },
  {
    text: "40",
    value: "40",
    selected: false
  },
  {
    text: "41",
    value: "41",
    selected: false
  },
  {
    text: "42",
    value: "42",
    selected: false
  },
  {
    text: "43",
    value: "43",
    selected: false
  },
  {
    text: "44",
    value: "44",
    selected: false
  },
  {
    text: "45",
    value: "45",
    selected: false
  },
  {
    text: "46",
    value: "46",
    selected: false
  },
  {
    text: "47",
    value: "47",
    selected: false
  },
  {
    text: "48",
    value: "48",
    selected: false
  },
  {
    text: "49",
    value: "49",
    selected: false
  },
  {
    text: "50",
    value: "50",
    selected: false
  },
  {
    text: "51",
    value: "51",
    selected: false
  },
  {
    text: "52",
    value: "52",
    selected: false
  },
  {
    text: "53",
    value: "53",
    selected: false
  },
  {
    text: "54",
    value: "54",
    selected: false
  },
  {
    text: "55",
    value: "55",
    selected: false
  },
  {
    text: "56",
    value: "56",
    selected: false
  },
  {
    text: "57",
    value: "57",
    selected: false
  },
  {
    text: "58",
    value: "58",
    selected: false
  },
  {
    text: "59",
    value: "59",
    selected: false
  }
];
const classesTypeValMapping = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5
};
const classesTypeZNMapping = {
  ONE: i18n.t("classesManage.singleShift"),
  TWO: i18n.t("classesManage.doubleShifts"),
  THREE: i18n.t("classesManage.threeShifts"),
  FOUR: i18n.t("classesManage.fourShifts"),
  FIVE: i18n.t("classesManage.fiveShifts")
};
const classesTypeMapping = ["ONE", "TWO", "THREE", "FOUR", "FIVE"];
const overlapHourMapping = {
  24: "00",
  25: "01",
  26: "02",
  27: "03",
  28: "04",
  29: "05",
  30: "06",
  31: "07",
  32: "08",
  33: "09",
  34: "10",
  35: "11",
  36: "12",
  37: "13",
  38: "14",
  39: "15",
  40: "16",
  41: "17",
  42: "18",
  43: "19",
  44: "20",
  45: "21",
  46: "22",
  47: "23",
  48: "00"
};
// 基础服务code列表
const moduleCodeList = ["alarm-center", "basic-manage", "asset-manage", "usercenter", "sys-manage"];
const modulePathList = [
  {
    code: "alarm-center",
    path: "/alarm"
  },
  {
    code: "basic-manage",
    path: "/basicManage"
  },
  {
    code: "asset-manage",
    path: "/asset"
  },
  {
    code: "usercenter",
    path: "/authority"
  },
  {
    code: "sys-manage",
    path: "/sysManage"
  }
];
const monthSettingList = [
  { id: "1", label: i18n.t("public.January") },
  { id: "2", label: i18n.t("public.February") },
  { id: "3", label: i18n.t("public.March") },
  { id: "4", label: i18n.t("public.April") },
  { id: "5", label: i18n.t("public.May") },
  { id: "6", label: i18n.t("public.June") },
  { id: "7", label: i18n.t("public.July") },
  { id: "8", label: i18n.t("public.August") },
  { id: "9", label: i18n.t("public.September") },
  { id: "10", label: i18n.t("public.October") },
  { id: "11", label: i18n.t("public.November") },
  { id: "12", label: i18n.t("public.December") }
];

const defalutData = [
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  },
  {
    0: {
      title: i18n.t("energy.peakHour"),
      icon: "tip",
      periodName: "TIP",
      price: 0,
      periodTimeList: []
    },
    1: {
      title: i18n.t("energy.highHour"),
      icon: "peak",
      periodName: "PEAK",
      price: 0,
      periodTimeList: []
    },
    2: {
      title: i18n.t("energy.normalHour"),
      icon: "flat",
      periodName: "FLAT",
      price: 0,
      periodTimeList: []
    },
    3: {
      title: i18n.t("energy.lowTime"),
      icon: "valley",
      periodName: "VALLEY",
      price: 0,
      periodTimeList: []
    }
  }
];
// 需要缓存的路由页面
const viewMap = [
  // 维度管理
  {
    name: "Dimension", // 不仅可以代表当前页面的name，还可以表示路由守卫中的from.name
    children: ["DimensionInfo", "RelevanceInfo"] // 当前页面包含的子页面，不区分层级，可以用于表示路由守卫中的to.name
  },
  // 资产管理
  {
    name: "Account",
    children: ["AccountInfo", "ImportLog", "ImportLogInfo"]
  },
  // 班制管理
  {
    name: "ClassesManage",
    children: ["ClassesDetail"]
  },
  // 能源价格
  {
    name: "CompanyElectric",
    children: ["EnergyDetail", "EnergyInfo", "AddEnergy"]
  }
];

// 10, 20, 50, 100
const defaultSizes = [
  {
    value: 10,
    name: "10"
  },
  {
    value: 20,
    name: "20"
  },
  {
    value: 50,
    name: "50"
  },
  {
    value: 100,
    name: "100"
  }
];
const InputMaxLimit = {
  limit20: 20,
  limit50: 50,
  limit100: 100,
  limit200: 200,
  limit500: 500,
  limit4000: 4000
};

InputMaxLimit.install = function(Vue) {
  Vue.prototype.$getInputMaxLimitConst = key => InputMaxLimit[key];
};

export {
  monthsList,
  checkTimeDaysList,
  classesTypeValMapping,
  classesTypeZNMapping,
  classesTypeMapping,
  hourNumList,
  minNumList,
  overlapHourMapping,
  moduleCodeList,
  modulePathList,
  viewMap,
  defaultSizes,
  monthSettingList,
  defalutData,
  InputMaxLimit
};
